import React from "react";
import { COLORS } from "../../../theme/colors";
import { SegmentedControl } from "../../../components/ui";
import Icon from "../../../components/Icon";

// agent-experience-redesign-v1.md §4.3 — Grid / List view toggle.
// Persists to localStorage so the user's choice survives reload.
// Per §16.2 #5: list mode kept indefinitely as escape hatch for power
// users with 50+ agents — not deprecated.
//
// Renders via the shared SegmentedControl primitive (icon-only segments).

const STORE_KEY = "library.viewMode";

export function readViewMode() {
  try { return localStorage.getItem(STORE_KEY) || "grid"; } catch { return "grid"; }
}
export function writeViewMode(mode) {
  try { localStorage.setItem(STORE_KEY, mode); } catch {}
}

export default function ViewModeToggle({ mode, onChange }) {
  // SegmentedControl auto-tints the active icon via parent text color;
  // we render the icon with currentColor so it picks up that state.
  const options = [
    { value: "grid", title: "Grid view",
      icon: <Icon name="block.box" size={14} color={mode === "grid" ? COLORS.text : COLORS.textDim} /> },
    { value: "list", title: "List view",
      icon: <Icon name="block.layers" size={14} color={mode === "list" ? COLORS.text : COLORS.textDim} /> },
  ];
  return (
    <SegmentedControl
      value={mode}
      onChange={(next) => { writeViewMode(next); onChange(next); }}
      options={options}
    />
  );
}
